import { createContext, useContext, useState, useCallback } from "react";
import { getPreviewProducer, setPreviewProducerModule } from "@/lib/api";

const PreviewContext = createContext(null);

export const PreviewProvider = ({ children }) => {
  const [preview, setPreview] = useState(() => getPreviewProducer());

  const startPreview = useCallback((producer) => {
    const p = { producer_id: producer.producer_id, name: producer.business_name || producer.name || "Producer" };
    setPreviewProducerModule(p);
    setPreview(p);
  }, []);

  const stopPreview = useCallback(() => {
    setPreviewProducerModule(null);
    setPreview(null);
  }, []);

  return (
    <PreviewContext.Provider value={{ preview, startPreview, stopPreview }}>
      {children}
    </PreviewContext.Provider>
  );
};

export const usePreview = () => useContext(PreviewContext);
